import './goalstyle-mega-menu-base-v5.js';

const goalStyleLigue1Route = () => {
  const root = window.Shopify?.routes?.root || '/';
  const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
  return `${normalizedRoot}collections/ligue-1`;
};

document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;

    const control = event.target.closest('[data-gs-filter="ligue-1"]');
    if (!control || !control.closest('[data-gs-mega-menu]')) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(goalStyleLigue1Route());
  },
  true,
);
